
export default {
    authenticated: false, //This is only for pnl farm
    conids: {}, // keep track of conid info, infd[conid] = name, ticker
    isMissingIServerAccount: false, // checks if selected portfolio account(not parent) has missing iserver account
    comboPositions: {}, // contains combo positions for each account ID
    portfolioModels: {}, // Cache portfolio model data
    portfolioModelsNlv: {}, // Cache model NLV
    portfolioPositions: {}, // Cache all portfolio positions
    pnlPositions: {}, // Cache all portfolio positions/combos/pnl from new pnl farm
    accountSummary: [], // { acctId, data }
    accountLedger: [], // { acctId, data }
    allocation: {},
    ibkramModels: [],
    accountMeta: {},
    ledgerModels: {}, // store models from a ledger with a given account
    portfolioPositionsSimple:{}, // a map of acctIds and its portfolio positions with simple=true in get request
    portfolioAccounts: [] // contains list of portfolio accounts returned by portfolio api
}
